import script from "./SubstatusTagManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubstatusTagManagement.vue?vue&type=script&setup=true&lang=ts"

import "./SubstatusTagManagement.vue?vue&type=style&index=0&id=65457440&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65457440"]])

export default __exports__